/*
 * @Date: 2018-08-03 13:40:10
 * @LastEditors: dwp
 * @LastEditTime: 2020-03-19 17:05:09
 * @Description: 全局请求权限列表model
 * @Company: Copyright (c) 2018. supOS
 */
import lodash from 'lodash';
import { getAuthMenu, checkADEnv } from '../services/api';
import menuFormatter from '../common/menu';

export default {
  namespace: 'authMenu',

  state: {
    basicMenu: [],
    designMenu: [],
    flatSystemMenu: [],
    flatBasicMenu: []
  },

  effects: {
    *fetchAuthMenu(_, { call, put }) {
      const response = yield call(getAuthMenu);
      const envData = yield call(checkADEnv);

      if (!(response && response.resource)) {
        return false;
      }
      const payload = menuFormatter(response.resource, _.payload.intl);
      const basicMenu = lodash.cloneDeep(payload.basicMenu) || [];
      const designMenu = lodash.cloneDeep(payload.designMenu) || [];
      const { username = '' } = JSON.parse(localStorage.getItem('loginMsg')) || {};

      // AD环境隐藏修改密码菜单
      if (envData && envData.type === 'AD' && username !== 'admin') {
        if (basicMenu) {
          basicMenu.forEach((item) => {
            if (item.id === 'personalInfo') {
              const pswIndex = lodash.findIndex(item.children, (o) => { return o.id === 'editPassword'; });
              item.children.splice(pswIndex, 1);
            }
          });
        }

        if (designMenu) {
          designMenu.forEach((item) => {
            if (item.id === 'personalInfo') {
              const pswIndex = lodash.findIndex(item.children, (o) => { return o.id === 'editPassword'; });
              item.children.splice(pswIndex, 1);
            }
          });
        }
      }

      yield put({
        type: 'initAuthMenu',
        payload
      });
      yield put({
        type: 'saveAuthMenu',
        payload: {
          ...payload,
          basicMenu,
          designMenu
        }
      });
      yield put({
        type: 'flatAuthMenu',
        payload
      });
    }
  },

  reducers: {
    initAuthMenu(state) {
      return {
        ...state,
        basicMenu: [],
        designMenu: [],
        flatSystemMenu: [],
        flatBasicMenu: []
      };
    },
    saveAuthMenu(state, { payload: { basicMenu, designMenu, hasSystemManage } }) {
      return {
        ...state,
        basicMenu,
        designMenu,
        hasSystemManage
      };
    },
    flatAuthMenu(state, { payload: { designMenu, basicMenu } }) {
      const authMenu = { flatSystemMenu: [], flatBasicMenu: [] };
      const flatmenu = (targetMenu, key) => {
        lodash.map(targetMenu, (item) => {
          if (item.children.length) {
            flatmenu(item.children, key);
          } else {
            authMenu[key].push(item);
          }
        });
      };
      flatmenu(designMenu, 'flatSystemMenu');
      flatmenu(basicMenu, 'flatBasicMenu');
      return {
        ...state,
        flatSystemMenu: authMenu.flatSystemMenu,
        flatBasicMenu: authMenu.flatBasicMenu
      };
    }
  }
};
